<template>
  <div class="page-wrapper">
    <ManageChannels @tab="switchTab" v-if="tab_switch == 'manage_channels'"></ManageChannels>
  </div>
</template>
<script>
import ManageChannels from "./ManageChannels.vue";
export default {
  components: {
    ManageChannels,
  },
  data: () => ({
    tab_switch: "manage_channels",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "manage_channels";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "channels", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>

